export default {
  playgroundGreen: "#42f4b3",
  danger: "#d80d0d"
};
